import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  private language$ = new BehaviorSubject<string>('en'); // Default language

  setLanguage(lang: string) {
    this.language$.next(lang);
    localStorage.setItem('selectedLanguage', lang); // Persist language selection
  }

  getLanguage(): Observable<string> {
    return this.language$.asObservable();
  }
}
